import cn from "classnames"

import styles from "./Flow.module.scss"

export const NumberLabel = ({ value }: { value: number | string }) => (
  <span className={cn(styles.text, styles.numberWrapper, styles.number)}>
    {value}
  </span>
)
